module.exports = __webpack_public_path__ + "static/media/b6_level_7.d38f7d39.png";